import SVG from 'react-inlinesvg';
import styles from './Banner.module.scss';
import classes from 'classnames';
import Robot from '@/assets/svg/Robot.svg';
import TutorAvatarIcon from '@/components/ConversationWithTutor/TutorAvatarIcon/TutorAvatarIcon';
import GoBackBtn from '@/components/GoBackBtn/GoBackBtn';
import { useTranslation } from 'react-i18next';
import downArrow from '@/assets/svg/down-arrow.svg';
interface BannerProps {
  layout?: 'activity' | 'fullPage' | 'history';
  onBackBtnClick?: () => void;
  tools?: any;
  goBackBtnText?: string;
  onMinimize?: () => void;
}

const Banner = ({
  layout = 'fullPage',
  onBackBtnClick,
  tools,
  goBackBtnText,
  onMinimize,
}: BannerProps) => {
  const { t } = useTranslation();

  const onHidePrivateTutor = () => {
    onBackBtnClick?.();
  };

  return (
    <div
      className={classes(styles.banner, {
        [styles.bannerInPopup]: layout === 'activity',
      })}
    >
      <div className={styles.toolsWrapper}>
        <div className={styles.tools}>
          <div>
            <GoBackBtn
              className={styles.backBtn}
              showIcon={true}
              emitClick={onHidePrivateTutor}
              text={goBackBtnText}
            />
          </div>
          <div className={styles.toolsRight}>
            {tools}
            {onMinimize && (
              <button
                className={styles.minimizeBtn}
                onClick={onMinimize}
                aria-label='Minimize tutor'
              >
                <SVG src={downArrow} />
              </button>
            )}
          </div>
        </div>
      </div>
      {/*<SVG className={styles.robot} src={Robot} />*/}
      <TutorAvatarIcon className={styles.robot} />
      <div className={styles.text}>
        {t(layout === 'activity' ? 'privateTutor' : 'myPrivateTutor')}
      </div>
    </div>
  );
};

export default Banner;
